import { IonContent, IonIcon, IonPage } from '@ionic/react';
import {
  settingsOutline,
  documentTextOutline,
  informationCircleOutline,
  chatbubblesOutline,
  notificationsOutline,
  chevronDownOutline,
  chevronUpOutline,
} from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import packageInfo from '../../../package.json';

export const LaunchPage = () => {
  const [phase, setPhase] = useState<'splash' | 'landing'>('splash');
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const t = setTimeout(() => setPhase('landing'), 1800);
    return () => clearTimeout(t);
  }, []);

  const navigate = (path: string) => {
    setMenuOpen(false);
    history.push(path);
  };

  return (
    <IonPage className="launch-page">
      <IonContent fullscreen>
        <div className="launch-bg">
          <div className="launch-coins-bg" />

          {phase === 'landing' && (
            <button
              className="launch-hamburger"
              onClick={() => setMenuOpen(true)}
              aria-label="Menu"
            >
              <img src="assets/icon/RoundMenu.png" alt="Menu" className="launch-hamburger-img" />
            </button>
          )}

          <div className="launch-center">
            <img
              src="assets/images/SlotCheck-landing.svg"
              alt="Slot Check"
              className="launch-logo"
            />
            {phase === 'splash' && <div className="launch-spinner" />}
          </div>

          {phase === 'landing' && (
            <div className="launch-footer">
              <button className="launch-btn-login" onClick={() => history.push('/auth/login')}>
                Log in
              </button>
              <p className="launch-version-text">App Version {packageInfo.version}</p>
            </div>
          )}
        </div>

        {menuOpen && (
          <div className="launch-menu-overlay" onClick={() => setMenuOpen(false)}>
            <div className="launch-menu-panel" onClick={(e) => e.stopPropagation()}>
              <div className="launch-menu-header">
                <img
                  src="assets/images/SlotCheck-White.png"
                  alt="Slot Check"
                  className="launch-menu-logo"
                />
              </div>

              <nav className="launch-menu-nav">
                {/* Notifications — hidden for now (kept in DOM, takes no space) */}
                <button
                  className="launch-menu-item"
                  style={{ display: 'none' }}
                  onClick={() => navigate('/notifications')}
                >
                  <IonIcon icon={notificationsOutline} className="launch-menu-icon" />
                  <span>Notifications</span>
                </button>

                {/* Settings — expandable */}
                <button className="launch-menu-item" onClick={() => setSettingsOpen((v) => !v)}>
                  <IonIcon icon={settingsOutline} className="launch-menu-icon" />
                  <span>Settings</span>
                  <IonIcon
                    icon={settingsOpen ? chevronUpOutline : chevronDownOutline}
                    className="launch-menu-chevron"
                  />
                </button>
                {settingsOpen && (
                  <div className="launch-menu-expand-content">
                    <button
                      className="launch-menu-sub-item launch-menu-sub-item--btn"
                      onClick={() => navigate('/terms')}
                    >
                      <IonIcon icon={documentTextOutline} className="launch-menu-icon" />
                      <span>Terms of Service</span>
                    </button>

                    <button
                      className="launch-menu-sub-item launch-menu-sub-item--btn"
                      onClick={() => setAboutOpen((v) => !v)}
                    >
                      <IonIcon icon={informationCircleOutline} className="launch-menu-icon" />
                      <span>About SlotCheck</span>
                      <IonIcon
                        icon={aboutOpen ? chevronUpOutline : chevronDownOutline}
                        className="launch-menu-chevron"
                      />
                    </button>
                    {aboutOpen && (
                      <div className="launch-menu-about-panel">
                        <p className="launch-menu-about-text">
                          SlotCheck is your companion for tracking slot machine performance and
                          managing your casino experience in real time.
                        </p>
                        <p className="launch-menu-about-version">v{packageInfo.version}</p>
                      </div>
                    )}

                    <button
                      className="launch-menu-sub-item launch-menu-sub-item--btn"
                      onClick={() => navigate('/contact-us')}
                    >
                      <IonIcon icon={chatbubblesOutline} className="launch-menu-icon" />
                      <span>Contact Support</span>
                    </button>
                  </div>
                )}
              </nav>

              <div className="launch-menu-footer">App Version {packageInfo.version}</div>
            </div>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};
